import React from 'react';
import { Star, Quote } from 'lucide-react';
const TESTIMONIALS = [{
  name: 'Profesora María González',
  age: '42 años',
  location: 'Buenos Aires',
  quote: 'Después de 15 años dando clases, pensé que ya había probado todo. Este kit me devolvió la confianza en el aula.'
}, {
  name: 'Profesor Carlos Mendoza',
  age: '35 años',
  location: 'Córdoba',
  quote: 'Las frases exactas para momentos críticos son oro puro. Ya no improviso, sé exactamente qué decir.'
}, {
  name: 'Profesora Laura Fernández',
  age: '28 años',
  location: 'Rosario',
  quote: 'Soy docente nueva y esto me salvó. Mis colegas no pueden creer el cambio en mi aula.'
}, {
  name: 'Profesor Roberto Díaz',
  age: '50 años',
  location: 'Mendoza',
  quote: 'Llevaba años gritando para pedir silencio. Ahora recupero la atención en segundos, sin levantar la voz.'
}, {
  name: 'Profesora Ana Martínez',
  age: '38 años',
  location: 'La Plata',
  quote: 'Lo mejor es que vuelvo a casa sin esa carga mental. Por fin puedo desconectar del trabajo.'
}];
export function TestimonialsSection() {
  return <section className="bg-gray-900 py-16 md:py-24 text-white" data-id="element-246">
      <div className="mx-auto max-w-6xl px-4" data-id="element-247">
        <h2 className="mb-16 text-center text-3xl font-bold text-white md:text-5xl" data-id="element-248">
          Lo que dicen otros docentes
        </h2>

        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3" data-id="element-249">
          {TESTIMONIALS.map((t, i) => <div key={i} className="relative rounded-xl bg-gray-800 p-8 shadow-xl border border-gray-700" data-id="element-250">
              <Quote className="absolute right-6 top-6 h-8 w-8 text-gray-600 opacity-50" data-id="element-251" />
              <div className="mb-4 flex gap-1 text-yellow-400" data-id="element-252">
                {[1, 2, 3, 4, 5].map(s => <Star key={s} className="h-4 w-4 fill-current" data-id="element-253" />)}
              </div>
              <p className="mb-6 text-lg italic text-gray-300" data-id="element-254">"{t.quote}"</p>
              <div className="border-t border-gray-700 pt-4" data-id="element-255">
                <p className="font-bold text-white" data-id="element-256">{t.name}</p>
                <p className="text-sm text-gray-400" data-id="element-257">
                  {t.age}, {t.location}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}